// 2026-09-09 - FormuLearning - 전역 알림 스토어 — 이슈 #72 (M901-05)
// 파일 위치: frontend/src/stores/toastStore.ts
// 표시는 `components/feedback/Toast.tsx`(ToastHost)가 전담한다. 여기는 큐만 쥔다.

import { create } from 'zustand'

export interface Toast {
  id: number
  message: string
  tone: 'info' | 'warn'
  durationMs: number
}

/** 동시에 쌓아 두는 최대 개수. 넘치면 오래된 것부터 밀어낸다. */
const MAX_TOASTS = 3

let nextId = 1

interface ToastState {
  toasts: Toast[]
  show: (message: string, tone?: Toast['tone'], durationMs?: number) => void
  dismiss: (id: number) => void
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  show: (message, tone = 'info', durationMs = 4000) =>
    set((s) => ({ toasts: [...s.toasts, { id: nextId++, message, tone, durationMs }].slice(-MAX_TOASTS) })),
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))

/** 컴포넌트 밖(스토어·핸들러)에서 부르는 단축 경로. */
export const toast = (message: string, tone: Toast['tone'] = 'info', durationMs = 4000) =>
  useToastStore.getState().show(message, tone, durationMs)
